import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'
import Loader from '../../Loader/Loader'

import { useUpdateGuessPassesData } from './hooks'

const MAX_GUEST_PASSES = 100
const MIN_GUEST_PASSES = 0

export const GuestPassesSection = ({ clientId, isLoading, totalGuestPasses, usedGuestPasses }) => {
  const { t } = useTranslation(['clients-legacy', 'common'])
  const [isEditing, setIsEditing] = useState(false)
  const [newTotalGuestPasses, setNewTotalGuestPasses] = useState(totalGuestPasses)

  const { isLoading: isFetchUpdateGuestPassesLoading, fetchUpdateGuestPasses } =
    useUpdateGuessPassesData(clientId)

  const handleEdit = () => {
    fetchUpdateGuestPasses({ totalPasses: newTotalGuestPasses })
    setIsEditing(false)
  }

  const handleTotalGuestPasses = (e) => {
    const preparedValue = parseInt(e.target.value)
    if (preparedValue) {
      return setNewTotalGuestPasses(
        preparedValue > MAX_GUEST_PASSES ? MAX_GUEST_PASSES : preparedValue,
      )
    }
    return setNewTotalGuestPasses(MIN_GUEST_PASSES)
  }

  useEffect(() => {
    setNewTotalGuestPasses(totalGuestPasses)
  }, [totalGuestPasses])

  if (isLoading || isFetchUpdateGuestPassesLoading) {
    return (
      <div className="guest-passes">
        <Loader />
      </div>
    )
  }

  const isTotalGuestPassesValid = newTotalGuestPasses >= usedGuestPasses

  return (
    <div className="guest-passes">
      <div className="title">
        {t('clients-legacy:profileView.guestPasses.title', {
          total: newTotalGuestPasses,
          used: usedGuestPasses,
        })}
      </div>
      {isEditing ? (
        <div className="guess-container">
          <span className="guess-passes-label">
            {t('clients-legacy:profileView.guestPasses.numberToUseAnnually')}
          </span>
          <input
            className="input guess-input"
            max={MAX_GUEST_PASSES}
            min={MIN_GUEST_PASSES}
            type="number"
            value={newTotalGuestPasses}
            onChange={handleTotalGuestPasses}
          />
          <button
            disabled={isFetchUpdateGuestPassesLoading || isLoading || !isTotalGuestPassesValid}
            className="button button-black"
            onClick={handleEdit}
          >
            {t('common:actions.save')}
          </button>
        </div>
      ) : (
        <span className="edit-icon" onClick={() => setIsEditing(true)}>
          <Icon icon="editPen" viewBox="2 2 20 20" />
        </span>
      )}
    </div>
  )
}

GuestPassesSection.propTypes = {
  clientId: PropTypes.number,
  isLoading: PropTypes.bool,
  totalGuestPasses: PropTypes.number,
  usedGuestPasses: PropTypes.number,
}
